// extracted by mini-css-extract-plugin
module.exports = {"root":"BurgerButton_root__S_8Cz","button":"BurgerButton_button__NHPc4","burger":"BurgerButton_burger__MfSS6"};